import { render, staticRenderFns } from "./ValidationError.vue?vue&type=template&id=39f4ccd9&"
import script from "./ValidationError.vue?vue&type=script&lang=ts&"
export * from "./ValidationError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f4ccd9')) {
      api.createRecord('39f4ccd9', component.options)
    } else {
      api.reload('39f4ccd9', component.options)
    }
    module.hot.accept("./ValidationError.vue?vue&type=template&id=39f4ccd9&", function () {
      api.rerender('39f4ccd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/ValidationError.vue"
export default component.exports